import { render, staticRenderFns } from "./FModalFooter.vue?vue&type=template&id=72d30cc0&"
import script from "./FModalFooter.vue?vue&type=script&lang=js&"
export * from "./FModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports